<template>
  <g>
    <text font-size="32" y="307.5" transform="translate(742.5)" fill="#fff"
      ><tspan :x="xPositions['d'] || '0'" :text-anchor="anchors['d'] || 'middle'" :dy="idx == 0 ? '0em' : '1.2em'" v-for="(word, idx) in words.d"  :key="idx" v-text="word"></tspan></text
    >
    
    <text font-size="32" y="453" transform="translate(791)" fill="#fff"
      ><tspan :x="xPositions['di'] || '0'" :text-anchor="anchors['di'] || 'middle'" :dy="idx == 0 ? '0em' : '1.2em'" v-for="(word, idx) in words.di"  :key="idx" v-text="word"></tspan></text
    >
    
    <text font-size="32" y="453" transform="translate(597)" fill="#fff"
      ><tspan :x="xPositions['ds'] || '0'" :text-anchor="anchors['ds'] || 'middle'" :dy="idx == 0 ? '0em' : '1.2em'" v-for="(word, idx) in words.ds" :key="idx" v-text="word"></tspan></text
    >
    
    <text font-size="32" y="259" transform="translate(597)" fill="#fff"
      ><tspan :x="xPositions['dc'] || '0'" :text-anchor="anchors['dc'] || 'middle'" :dy="idx == 0 ? '0em' : '1.2em'" v-for="(word, idx) in words.dc" :key="idx" v-text="word"></tspan></text
    >
    
    <text font-size="32" y="792.5" transform="translate(742.5)" fill="#fff"
      ><tspan :x="xPositions['i'] || '0'" :text-anchor="anchors['i'] || 'middle'" :dy="idx == 0 ? '0em' : '1.2em'" v-for="(word, idx) in words.i" :key="idx" v-text="word"></tspan></text
    >
    
    <text font-size="32" y="647" transform="translate(791)" fill="#fff"
      ><tspan :x="xPositions['id'] || '0'" :text-anchor="anchors['id'] || 'middle'" :dy="idx == 0 ? '0em' : '1.2em'"  v-for="(word, idx) in words.id" :key="idx" v-text="word"></tspan></text
    >
    
    <text font-size="32" y="841" transform="translate(597)" fill="#fff"
      >
      <tspan :x="xPositions['is'] || '0'" :text-anchor="anchors['is'] || 'middle'" :dy="idx == 0 ? '0em' : '1.2em'" v-for="(word, idx) in words.is" :key="idx" v-text="word"></tspan></text
    >
    
    <text font-size="32" y="647" transform="translate(597)" fill="#fff">
      <tspan :x="xPositions['ic'] || '0'" :text-anchor="anchors['ic'] || 'middle'" :dy="idx == 0 ? '0em' : '1.2em'" v-for="(word, idx) in words.ic" :key="idx" v-text="word"></tspan></text
    >
    
    <text font-size="32" y="792.5" transform="translate(257.5)" fill="#fff"
      ><tspan :x="xPositions['s'] || '0'" :text-anchor="anchors['s'] || 'middle'" :dy="idx == 0 ? '0em' : '1.2em'" v-for="(word, idx) in words.s" :key="idx" v-text="word"></tspan></text
    >
    
    <text font-size="32" y="647" transform="translate(403)" fill="#fff"
      ><tspan :x="xPositions['sd'] || '0'" :text-anchor="anchors['sd'] || 'middle'" :dy="idx == 0 ? '0em' : '1.2em'" v-for="(word, idx) in words.sd" :key="idx" v-text="word"></tspan></text
    >
    
    <text font-size="32" y="841" transform="translate(403)" fill="#fff"
      ><tspan :x="xPositions['si'] || '0'" :text-anchor="anchors['si'] || 'middle'" :dy="idx == 0 ? '0em' : '1.2em'" v-for="(word, idx) in words.si" :key="idx" v-text="word"></tspan></text
    >
    
    <text font-size="32" y="647" transform="translate(209)" fill="#fff"
      ><tspan :x="xPositions['sc'] || '0'" :text-anchor="anchors['sc'] || 'middle'" :dy="idx == 0 ? '0em' : '1.2em'" v-for="(word, idx) in words.sc" :key="idx" v-text="word"></tspan></text
    >
    
    <text font-size="32" y="307.5" transform="translate(257.5)" fill="#fff"
      ><tspan :x="xPositions['c'] || '0'" :text-anchor="anchors['c'] || 'middle'" :dy="idx == 0 ? '0em' : '1.2em'" v-for="(word, idx) in words.c" :key="idx" v-text="word"></tspan></text
    >
    
    <text font-size="32" y="259" transform="translate(403)" fill="#fff"
      ><tspan :x="xPositions['cd'] || '0'" :text-anchor="anchors['cd'] || 'middle'" :dy="idx == 0 ? '0em' : '1.2em'" v-for="(word, idx) in words.cd" :key="idx" v-text="word"></tspan></text
    >
    
    <text font-size="32" y="453" transform="translate(403)" fill="#fff"
      ><tspan :x="xPositions['ci'] || '0'" :text-anchor="anchors['ci'] || 'middle'" :dy="idx == 0 ? '0em' : '1.2em'" v-for="(word, idx) in words.ci" :key="idx" v-text="word"></tspan></text
    >
    
    <text font-size="32" y="453" transform="translate(209)" fill="#fff"
      ><tspan :x="xPositions['cs'] || '0'" :text-anchor="anchors['cs'] || 'middle'" :dy="idx == 0 ? '0em' : '1.2em'" v-for="(word, idx) in words.cs" :key="idx" v-text="word"></tspan
    ></text>
  </g>
</template>

<script>
import { reduce } from 'lodash';

export default {
  props: {
    selectedWords: {
      type: Array,
      required: false,
      default: [],
    },
  },

  computed: {
    words() {
      return reduce(
        this.selectedWords,
        function (obj, word) {

          if(obj[word.zone.substr(0, 2)] === undefined) {
            obj[word.zone.substr(0, 2)] = [];
          }

          obj[word.zone.substr(0, 2)].push(word.word);
          
          return obj;
        },
        {}
      );
    },

    anchors() {
      let words = this.words;
      
      return reduce(
        words,
        function (obj, word, zone) {

          obj[zone.substr(0, 2)] = 'middle';

          if(zone == 'id' && words['ic'] !== undefined) {
            obj[zone.substr(0, 2)] = 'start';
          }
          // if(zone == 'ds' && words['di'] !== undefined) {
          //   obj[zone] = 'end';
          // }
          // if(zone == 'ci' && words['cs'] !== undefined) {
          //   obj[zone] = 'start';
          // }
          // if(zone == 'sd' && words['sc'] !== undefined) {
          //   obj[zone] = 'start';
          // }

          return obj;
        },
        {}
      );
    },

    xPositions() {
      let words = this.words;
      
      return reduce(
        words,
        function (obj, word, zone) {

          obj[zone.substr(0, 2)] = '0';

          if(zone == 'id' && words['ic'] !== undefined) {
            obj[zone.substr(0, 2)] = '-25';
          }
          // if(zone == 'ds' && words['di'] !== undefined) {
          //   obj[zone] = 'end';
          // }
          // if(zone == 'ci' && words['cs'] !== undefined) {
          //   obj[zone] = 'start';
          // }
          // if(zone == 'sd' && words['sc'] !== undefined) {
          //   obj[zone] = 'start';
          // }

          return obj;
        },
        {}
      );
    },
  },
};
</script>

<style>
/* tspan {
  font-size: 5px !important;
} */
</style